exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js!./button.css"), "");

// module
exports.push([module.id, ".MapView {\n}\n.MapView .panel {\n  position: absolute;\n  top: 25px;\n  right: 0;\n  z-index: 1;\n  width: 140px;\n  margin: 5px;\n  padding: 3px;\n  background-color: white;\n  opacity: 0.7;\n}\n.MapView .ol-mouse-position {\n  background-color: white;\n  opacity: 0.7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist!./src/map/MapView.less
// module id = 121
// module chunks = 0